<!-- all other installation types -->
<ng-container
  *ngIf="
    (heatingRegulation$ | async | ready | value2: featurePropertyKey.mode) !==
      HeatingConfigurationRegulationMode.ConstantControlledWithExternalThermostat;
    else constantControlled
  "
>
  <div
    class="section-wrapper"
    *ngIf="
      (shouldDispalyHeatingPanel$ | async) ||
      ((eco$ | async | ready) && !(heatingPanelService.isEcoMode$ | async)) ||
      ((comfort$ | async | ready) && !(heatingPanelService.isComfortMode$ | async))
    "
  >
    <app-banner *ngIf="isVCSOptimizationActive$ | async" class="m-2" [type]="'warning'">
      {{
        '+INSTALLATIONS.INSTALLATION.CIRCUIT.ROOM_CHANNELS_PILL.STATUS_INFO.VCSO_ACTIVE_MESSAGE'
          | translate
      }}
    </app-banner>
    <h3>
      {{ '+INSTALLATIONS.INSTALLATION.HEATING_CIRCUIT_OVERLAY.TIME_SCHEDULE.TITLE' | translate }}
    </h3>
    <app-heating-panel [circuitId]="circuitId"></app-heating-panel>
  </div>
</ng-container>

<!-- ConstantControlledWithExternalThermostat installation type does not have a schedule and has just single program 'normal/standard'-->
<ng-template #constantControlled>
  <div *ngIf="activeOperatingProgram$ | async | ready as mode" class="section-wrapper">
    <h3>
      {{ '+INSTALLATIONS.INSTALLATION.HEATING_CIRCUIT_OVERLAY.TEMPERATURES.TITLE' | translate }}
    </h3>
    <vi-program-item
      [program]="mode.feature | modeName: 'program'"
      [hasTemperature]="!!mode?.properties?.temperature?.value"
      [displayProgramTile]="false"
    >
      <vi-text name *ngIf="!(mode | executable: 'setTemperature')" class="flex-1">
        {{ mode.feature | modeName }}
      </vi-text>
      <app-temperature-select
        item
        *ngIf="mode | executable: 'setTemperature'"
        id="program-{{ mode.feature | modeName }}"
        [title]="mode.feature | modeName | translateOperatingProgram"
        [rangeDefinition]="mode | constraints: 'setTemperature':'targetTemperature'"
        [value]="mode.properties?.temperature?.value"
        gtm="onSet"
        gtmAction="Program temperature"
        gtmCategory="heatingSchedule"
        (valueChange)="onProgramTemperatureChange($event, mode.feature)"
      ></app-temperature-select>
    </vi-program-item>
  </div>
</ng-template>
